<div *ngIf="gearAppService?.GearMonitorLiterals && appService?.CoreCommonLiterals">
  <div *ngIf="!isSharedView">
    <div class="page-title my-4 my-sm-0">
      <div class="row align-items-center justify-content-between">
        <div class="col-sm-6 mb-sm-0 mb-2">{{gearAppService?.GearCommonLiterals?.AssetTracking}}</div>
        <div class="col-sm-6">
          <div class="form-row align-items-center justify-content-end">
            <div class="col-2 col-md-auto text-right">
              <button id="tanks-btn-collapsed" type="button" class="btn btn-primary" (click)="sidebar.open()" aria-controls="filters" [tooltip]="appService?.CoreCommonLiterals?.Filter">
                <i class="fa fa-filter"></i>
              </button>
            </div>
            <div class="col-2 col-md-auto text-right" *ngIf="assetTrackingPermissions.CanShowRoutes || assetTrackingPermissions.CanShowGeozones">
              <button id="tanks-btn-collapsed" type="button" class="btn btn-primary" (click)="sidebar2.open()" aria-controls="configurations" [tooltip]="appService?.CoreCommonLiterals?.AssetTrackingConfiguration">
                <i class="fas fa-sliders-h"></i>
              </button>
            </div>
            <div class="col-2 col-md-auto text-right">
              <button type="button" class="btn btn-primary" id="assets-btn-shared" (click)="sharedAssets()" [tooltip]="appService?.CoreCommonLiterals?.ShareAssetTracking">
                <i class="fas fa-share-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <lib-sidebar #sidebar id="filters" [title]="appService?.CoreCommonLiterals?.Filter" [invisibleBackdrop]="true">
      <div class="form-group">
        <lib-datepicker
          [labelText]="appService?.CoreCommonLiterals?.Date"
          name="dateFrom"
          id="dateFrom"
          [defaultToday]="true"
          [disabledFutureDates]="true"
          [(ngModel)]="dateFrom"
          (ngModelChange)="applyFilters('dateFrom')"
          [maxDate]="today"
        ></lib-datepicker>
      </div>
      <div class="form-group" *ngIf="assetTrackingPermissions.CanFilterAssets">
        <label>{{appService?.CoreCommonLiterals?.AssetTypeVehicles}}
          <span triggers="hover" [tooltip]="appService?.CoreCommonLiterals?.VehicleListTooltip" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
        <ss-multiselect-dropdown
          [texts]="multiSelectTexts"
          [name]="assets"
          id="assets"
          [settings]="assetsMultiSelectSettings"
          [options]="assetsList"
          [(ngModel)]="assets"
          (ngModelChange)="applyFilters('assets')"
        >
        </ss-multiselect-dropdown>
      </div>
      <div class="form-group" *ngIf="assetTrackingPermissions.CanFilterDrivers">
        <label>{{gearAppService.GearCommonLiterals.VehicleDrivers}}
          <span triggers="hover" [tooltip]="appService?.CoreCommonLiterals?.DriversListTooltip" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
        <ss-multiselect-dropdown
          [texts]="multiSelectTexts"
          [name]="drivers"
          id="drivers"
          [settings]="multiSelectSettings"
          [options]="driversList"
          [(ngModel)]="drivers"
          (ngModelChange)="applyFilters('drivers')"
        >
        </ss-multiselect-dropdown>
      </div>
      <div class="form-group" *ngIf="assetTrackingPermissions.AlarmFilters === alarmsTags.usingTags">
        <label>{{appService?.CoreCommonLiterals?.Alerts}}
          <span triggers="hover" [tooltip]="appService?.CoreCommonLiterals?.ShowAlertsTooltip" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
        <ss-multiselect-dropdown
          [texts]="multiSelectTexts"
          [name]="tags"
          id="tags"
          [settings]="assetsMultiSelectSettings"
          [options]="tagsList"
          [(ngModel)]="tags"
          (ngModelChange)="applyFilters('tags')"
        >
        </ss-multiselect-dropdown>
      </div>

    </lib-sidebar>

    <lib-sidebar #sidebar2 id="configurations" [title]="appService?.CoreCommonLiterals?.AssetTrackingConfiguration" [invisibleBackdrop]="true">
      <div class="form-group">
        <div class="custom-control custom-checkbox mt-0 mt-md-2" *ngIf="assetTrackingPermissions.CanShowRoutes">
          <input type="checkbox"
            class="custom-control-input"
            id="showRoute"
            value="showRoute"
            [(ngModel)]="showRoute"
            (change)="applyFilters('showRoute')"
            [disabled]="!isToday">
          <label class="custom-control-label" for="showRoute">{{gearAppService?.GearMonitorLiterals?.ShowRoute}}</label>
          <span triggers="hover" [tooltip]="gearAppService?.GearMonitorLiterals?.ShowRouteInfo" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </span>
        </div>
      </div>
      <div class="form-group" *ngIf="assetTrackingPermissions.CanShowGeozones">
        <label>{{appService?.CoreCommonLiterals?.ShowGeozones}}
          <span triggers="hover" [tooltip]="appService?.CoreCommonLiterals?.GeozoneListTooltip" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
        <ss-multiselect-dropdown
          [texts]="multiSelectTexts"
          [name]="geozones"
          id="geozones"
          [settings]="multiSelectSettings"
          [options]="geozonesList"
          [(ngModel)]="geozones"
          (ngModelChange)="applyFilters('geozones')"
        >
        </ss-multiselect-dropdown>
      </div>
    </lib-sidebar>
  </div>

  <div class="screen-container" [ngClass]="{'m-0': isSharedView}" *ngIf="!environment.useOfflineMode">
    <agm-map
      #agmMap
      [fitBounds]="bounds"
      [latitude]="latitudeCenter"
      [longitude]="longitudeCenter"
      [mapTypeId]="showSatellitalView ? 'satellite' : 'roadmap'"
      [styles]="mapStyles"
      [maxZoom]="commonMapService.MaxZoom"
      (mapReady)="onInitMap($event)"
      [zoom]="_zoom"
      [ngClass]="{'vh-100': isSharedView}"
    >
      <agm-map-type-control></agm-map-type-control>
      <ng-container *ngIf="mapReady && this.appService.mapIconSet?.value?.length">
        <agm-marker
          *ngFor="let m of mapAssets"
          #marker
          [latitude]="m?.CurrentLocation?.Latitude"
          [longitude]="m?.CurrentLocation?.Longitude"
          (markerClick)="openDetail(m?.Asset?.AssetID)"
          (mouseOver)="activeMarker = m?.Asset?.AssetID"
          (mouseOut)="activeMarker = 0"
          [iconUrl]='{"url": m?.iconUrl,"scaledSize": {"width": (m?.Asset?.IconID === 0 ? 25 : 32),"height": (m?.Asset?.IconID === 0 ? 40 : 32)}}'
          [visible]="(m?.CurrentLocation?.Latitude && m?.CurrentLocation?.Longitude) ? true : false"
        >
        <!--
          [iconUrl]='{"url": m?.iconUrl ? m?.iconUrl : "" ,"scaledSize": {"width": (m?.Asset?.IconID === 0 ? 25 : 32),"height": (m?.Asset?.IconID === 0 ? 40 : 32)}}'
          iconUrl]='{"url": getMarkerIcon(m),"scaledSize": {"width": (m?.Asset?.IconID === 0 ? 25 : 32),"height": (m?.Asset?.IconID === 0 ? 40 : 32)}}' -->
          <agm-info-window *ngIf="m?.Asset" [disableAutoPan]="false" [isOpen]="m.Asset.AssetID === activeMarker" maxWidth="100%">
            <div class="marker-tooltip">
              <div class="tooltip-header">
                <span class="tooltip-title text-primary">
                  <i class="fa-solid {{assetMapIcon}} mr-1"></i> {{m.Asset.Description}}
                </span>
                <span class="tooltip-close mb-1">✖</span>
              </div>
              <div class="tooltip-body mt-1">
                <div class="tooltip-description">
                  <span class="d-block mb-2">
                    <i class="fa-solid fa-id-card mr-1 mb-1"></i>
                    <strong class="font-weight-bold">{{appService?.CoreCommonLiterals?.LicensePlateNumber}}</strong><br>
                    {{m.Asset.AssetVehicleData.LicensePlateNumber}}
                  </span>
                  <span *ngIf="isToday" style="display: block; width: 100%;">
                    <i class="fa-solid fa-clock mr-1 mb-1"></i>
                    <strong class="font-weight-bold">{{gearAppService?.GearMonitorLiterals?.LastUpdate}}</strong><br>
                    {{m.LastStatusLocalDateTimeString}}
                  </span>
                  <div class="mt-2" *ngIf="m?.Alarms?.InformationAlarmCount || m?.Alarms?.LowAlarmCount || m?.Alarms?.MidAlarmCount || m?.Alarms?.HighAlarmCount">
                    <span>
                      <i class="fa-solid fa-warning mr-1 mb-1"></i>
                      <strong class="font-weight-bold">{{appService.CoreCommonLiterals.Alarms}}:</strong>
                    </span>
                    <div class="mt-2">
                      <span class="badge badge-info mr-1" *ngIf="m?.Alarms?.InformationAlarmCount">
                        {{appService.CoreCommonLiterals.InformationAlarm}} : {{m?.Alarms?.InformationAlarmCount}}
                      </span>
                      <span class="badge badge-yellow mr-1" style="background-color: #fedc07 !important;" *ngIf="m?.Alarms?.LowAlarmCount">
                        {{ appService.CoreCommonLiterals.LowAlarm}} : {{m?.Alarms?.LowAlarmCount}}
                      </span>
                      <span class="badge badge-warning mr-1" *ngIf="m?.Alarms?.MidAlarmCount">
                        {{ appService.CoreCommonLiterals.MediumAlarm }}: {{m?.Alarms?.MidAlarmCount}}
                      </span>
                      <span class="badge badge-danger mr-1" *ngIf="m?.Alarms?.HighAlarmCount">
                        {{ appService.CoreCommonLiterals.HighAlarm}}: {{m?.Alarms?.HighAlarmCount}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </agm-info-window>
        </agm-marker>
      </ng-container>
    </agm-map>
  </div>
  <div class="map-section d-flex align-items-center justify-content-center" *ngIf="environment.useOfflineMode">
    <div class="alert alert-warning text-center m-3 w-100">
      <i class="fas fa-map-marked-alt fa-3x mb-3"></i>
      <h4>{{ 'Maps disabled'}}</h4>
      <p>{{'Maps are not available in offline mode.'}}</p>
    </div>
  </div>
</div>


<modal
  #detailModal
  [closeButtonText]="appService?.CoreCommonLiterals?.ButtonClose"
  id="assetDetailModal"
  modalClass="modal-lg"
  (onClose)="detailActiveTab = 1"
>
  <modal-header>{{assetDetail?.Asset.Description}}</modal-header>
  <modal-content>
    <div *ngIf="assetDetailStatus === 1" class="text-center">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
    <div *ngIf="assetDetail && assetDetailStatus === 0">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" *ngFor="let tab of detailModalTabs; let i = index">
          <a type="button" class="nav-link" role="tab" (click)="detailActiveTab = i+1" [ngClass]="{'active': detailActiveTab === i+1}">{{tab.description}}</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade mt-3" [ngClass]="{'active show': detailActiveTab === 1}">
          <table class="table">
            <tbody>
              <tr>
                <td>{{appService?.CoreCommonLiterals?.LicensePlateNumber}}</td>
                <td>{{assetDetail.Asset?.AssetVehicleData?.LicensePlateNumber}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade mt-3" [ngClass]="{'active show': detailActiveTab === 2}">
          <table class="table">
            <thead>
              <tr>
                <th>{{appService?.CoreCommonLiterals?.Description}}</th>
                <th>{{gearAppService?.GearCommonLiterals?.Status}}</th>
                <th>{{gearAppService?.GearMonitorLiterals?.LastUpdate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let endpoint of assetDetail.EndpointsStatus">
                <td>{{endpoint.Description}}</td>
                <td>{{endpoint.DisplayValue}}</td>
                <td>{{endpoint.LastStatusLocalDateTimeString}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade mt-3" [ngClass]="{'active show': detailActiveTab === 3}">
          <table class="table">
            <thead>
              <tr>
                <th>{{appService?.CoreCommonLiterals?.Description}}</th>
                <th>{{appService?.CoreCommonLiterals?.EndpointWord}}/{{appService?.CoreCommonLiterals?.Device}}</th>
                <th>{{appService?.CoreCommonLiterals?.Date}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let alarm of assetDetail.Alarms">
                <td>{{alarm.Description}}</td>
                <td>{{alarm.DeviceEndpointDescription}}</td>
                <td>{{alarm.LocalDateTimeString}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade mt-3" [ngClass]="{'active show': detailActiveTab === 4}">
          <table class="table">
            <thead>
              <tr>
                <th>{{appService?.CoreCommonLiterals?.FullName}}</th>
                <th>{{appService?.CoreCommonLiterals?.Email}}</th>
                <th>{{appService?.CoreCommonLiterals?.PhoneNumber}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let driver of assetDetail.DriverAccounts">
                <td>{{driver.Firstname}} {{driver.Lastname}}</td>
                <td>{{driver.EMail}}</td>
                <td>{{driver.PhoneNumber}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          *ngFor="let customerTab of customerTabs; let t = index"
          class="tab-pane fade mt-3"
          [ngClass]="{'active show': detailActiveTab === (detailModalTabs?.length-customerTabs?.length+(t+1))}"
        >
          <tabs-container [component]="customerTab.component" [data]="{detail: assetDetail, date: assetDetailDate}"></tabs-container>
        </div>
      </div>
    </div>
  </modal-content>
</modal>

<modal
  #showRouteModal
  id="assetRouteModal"
  modalClass="modal-lg"
  [submitButtonText]="appService?.CoreCommonLiterals?.ButtonSave"
  (onSubmit)="saveAssetsRoutes(formElement)"
  [errorMessage]="errorMessage"
  (onClose)="closeModalRoutes()"
  [otherButtonText]="appService?.CoreCommonLiterals?.ButtonCancel"
  (onAction)="onCloseModalRoutes()"
>
  <modal-header>{{gearAppService?.GearMonitorLiterals?.ShowRoute}}</modal-header>
  <modal-content>
    <form #formElement="ngForm" class="row">
      <div class="form-group col-12">
        <p>{{gearAppService?.GearMonitorLiterals?.ShowRouteLimitInfo}}</p>
        <label for="assetsRoute">{{appService?.CoreCommonLiterals?.AssetTypeVehicles}}</label>
        <ss-multiselect-dropdown
          [texts]="multiSelectTexts"
          name="assetsRoute"
          id="assetsRoute"
          [settings]="assetsMultiSelectSettings"
          [options]="assetsListRoute"
          [(ngModel)]="assetsRoute"
          required>
        </ss-multiselect-dropdown>
      </div>
    </form>
  </modal-content>
</modal>

